module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAWCAMAAADD5o0oAAAAn1BMVEUAAAD////jxo7ms4DouYvdu4jntobiun/lu3/evYTjuIDiuYDju4LhuoLhvIDhvIHhuYHiuoDhu4LivIHiu4Hju4Lju4Hju4HhuoHhu4HhvIDiuoHiu4DivIHiu4HiuoDjvILhu4Hiu4Hiu4Hju4Hiu4HiuoHiu4Hiu4HiuoHiu4Hiu4Hiu4Hhu4Hiu4Hiu4Hiu4Hiu4Hiu4Hiu4Hiu4GpmtmAAAAANHRSTlMAAQkKCw8VGh4fJCwtO0RFTU5WV2FsbXV3gIGCi4yOp73Gx83O09Tb4uPm5+ry8/X4+fz+A2ru1gAAAIJJREFUGBk1wYkWgVAYRtEvUmSe58ocUuK8/7NZ6/rbWzVv/1qrFkMpswUS/a2AtCFnARx8ObMvnFpyph+4BHLGFdxCOcMKsracfgmPSH8Z5F2ZDPKeTL+EZyQzeMO9IzOq4BbKTD5wDWRmXzi3ZObA0ZdZAmlTZgMkqsVQqObtivUPl+sRNYiBlGUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/image/left2.png
// module id = dXUM
// module chunks = 1